(() => {
  const section = document.querySelector('[data-bz-test-ride]');
  if (!section) return;

  // Remove the global terms and conditions section on this page
  const termsBox = document.querySelector('[class*="ai-terms-box"]');
  if (termsBox) termsBox.remove();

  const dataLayer = window.dataLayer || (window.dataLayer = []);
  const scrollButtons = section.querySelectorAll('[data-bz-scroll-target]');

  const scrollToTarget = (selector) => {
    const target = section.querySelector(selector);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  scrollButtons.forEach((button) => {
    button.addEventListener('click', () => {
      scrollToTarget(button.getAttribute('data-bz-scroll-target'));
      dataLayer.push({ event: 'bz_cta_click', cta: button.dataset.bzCta || 'unknown' });
    });
  });

  // Capture UTM parameters from URL with sessionStorage persistence
  const UTM_STORAGE_KEY = 'bz_utm_params';
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  const getUTMParams = () => {
    const params = new URLSearchParams(window.location.search);
    const fromURL = {};
    let hasURLParams = false;

    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) {
        fromURL[key] = value;
        hasURLParams = true;
      }
    });

    // If URL has UTM params, save to sessionStorage and use them
    if (hasURLParams) {
      try {
        sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(fromURL));
      } catch (e) {
        // sessionStorage not available
      }
      return UTM_KEYS.reduce((acc, key) => ({ ...acc, [key]: fromURL[key] || '' }), {});
    }

    // Otherwise, try to retrieve from sessionStorage (user navigated within session)
    try {
      const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return UTM_KEYS.reduce((acc, key) => ({ ...acc, [key]: parsed[key] || '' }), {});
      }
    } catch (e) {
      // sessionStorage not available or invalid JSON
    }

    // No UTM params found anywhere
    return UTM_KEYS.reduce((acc, key) => ({ ...acc, [key]: '' }), {});
  };

  const utmParams = getUTMParams();

  const setFieldValues = (formEl, selector, value) => {
    if (!formEl) return false;
    const fields = formEl.querySelectorAll(selector);
    if (!fields.length) return false;
    const safeValue = value ?? '';
    fields.forEach((field) => {
      field.value = safeValue;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return true;
  };

  const applyUTMsToForm = (formEl) => {
    if (!formEl) return;
    Object.keys(utmParams).forEach((key) => {
      setFieldValues(formEl, `[name="${key}"]`, utmParams[key] || '');
    });
  };

  const accordions = section.querySelectorAll('.bz-faq__accordion');
  accordions.forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      const summary = event.target.closest('summary');
      if (!summary) return;
      const item = summary.parentElement;
      if (!item || !item.classList.contains('bz-faq__item')) return;

      // Track FAQ interaction (only when opening)
      if (!item.hasAttribute('open')) {
        const questionText = summary.textContent?.trim().replace(/\s+/g, ' ').slice(0, 100);
        dataLayer.push({
          event: 'bz_faq_opened',
          faq_question: questionText
        });
      }

      accordion.querySelectorAll('.bz-faq__item[open]').forEach((openItem) => {
        if (openItem !== item) openItem.removeAttribute('open');
      });
    });
  });

  const formTarget = section.querySelector('#bz-hubspot-form');

  const initHubspotForm = () => {
    if (!formTarget) return false;
    if (!window.hbspt || !window.hbspt.forms || !window.hbspt.forms.create) return false;

    const formId = formTarget.dataset.formId?.trim();
    const portalId = formTarget.dataset.portalId || '20111578';
    const region = formTarget.dataset.region || 'na1';

    if (!formId) {
      console.error('BZ test ride form missing required data-form-id on #bz-hubspot-form');
      return false;
    }

    window.hbspt.forms.create({
      region,
      portalId,
      formId,
      target: '#bz-hubspot-form',
      onFormReady: (form) => {
        const loading = formTarget.querySelector('.bz-form-loading');
        if (loading) loading.remove();
        const formEl = form?.[0] || formTarget.querySelector('form');

        // Apply all captured data to form when ready
        applyUTMsToForm(formEl);
      },
      onBeforeFormSubmit: (form) => {
        const formEl = form?.[0] || formTarget.querySelector('form');

        // Re-apply all data right before submit (ensures latest selections)
        applyUTMsToForm(formEl);
      },
      onFormSubmitted: () => {
        dataLayer.push({ event: 'bz_form_success', form: 'test-ride' });
      }
    });

    return true;
  };

  const waitForHubspot = () => {
    if (initHubspotForm()) return;
    window.setTimeout(waitForHubspot, 300);
  };

  waitForHubspot();

})();
